import { loc } from "../../../core/utils"
import React from "react"

function PassworErrorMessageHandler({ values, errors, hasValidationErrors }) {
  const validationItems = [
    "one_lower_case_required",
    "one_upper_case_required",
    "one_number_required",
    "more_than_height_length",
    "different_password",
    "confirmation_password_matches_new_password"
  ]

  function isErrorPresent(errors, errorType) {
    if (!errors || errors.length === 0) return false
    return errors.includes(errorType)
  }

  return (
    <section style={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
      {validationItems.map((item) => {
        return (
          <div key={item}>
            <span>
              {isErrorPresent(errors.newPassword, item) ? (
                <i style={{ color: "red" }} className="fa fa-window-close" />
              ) : (
                <i style={{ color: "green" }} className="fas fa-check" />
              )}
            </span>{" "}
            {loc(item)}
          </div>
        )
      })}
    </section>
  )
}

export default PassworErrorMessageHandler
